import styled from 'styled-components'

export const Hint = styled.span`
  font-size: 1em;
  line-height: 1.5em;
  opacity: 0.2;
  color: ${({ theme }) => theme.mediumGrey};
  opacity: 0.2;
`
